import React from 'react';

export const makePlaceholdersArray = (quantity: number, placeholder: React.ReactElement) => (
  new Array(quantity).fill(null).map((_, idx) => React.cloneElement(placeholder, { key: idx }))
);
